const Permission = {
  StationCreate: "station:create",
  StationEdit: "station:edit",

  PbuCreate: "pbu:create",
  PbuEdit: "pbu:edit",
  PbuCancel: "pbu:cancel",

  PriceMovementCreate: "price-movement:create",
  PriceMovementEdit: "price-movement:edit",
  PriceMovementDelete: "price-movement:delete",
};

export default Permission;
